import { MutationResponse } from '@/api/types/common.types';

export enum PaymentMethod {
  Card = 'CARD',
  Wallet = 'WALLET',
  My_card = 'MY_CARD',
  Portmanat = 'PORTMANAT',
  Terminal = 'TERMINAL',
  Reimbursement = 'REIMBURSEMENT',
  Reversal = 'REVERSAL',
}

export enum PaymentProvider {
  Azericard = 'AZERICARD',
  Goldenpay = 'GOLDENPAY',
  Kapitalbank = 'KAPITALBANK',
  Yigim = 'YIGIM',
}

export enum TerminalPaymentTargetType {
  Ad = 'ad',
  Invoice = 'invoice',
  Balance = 'balance',
}

export enum PaymentService {
  Add_balance_custom = 'add_balance_custom',
  Pay_invoice = 'pay_invoice',
}

export enum PaymentStatus {
  Success = 'success',
  Failure = 'failure',
  Duplicate = 'duplicate',
  ContinueToWebsite = 'continue_to_website',
}

export enum PaymentCreateYigimTemplateGroupEnum {
  Mobile = 'GPL',
  Desktop = 'TPL',
}

export enum PaymentReferrer {
  Mobile_ad_prolong_promo = 'MOBILE_AD_PROLONG_PROMO',
  Desktop_ad_prolong_promo = 'DESKTOP_AD_PROLONG_PROMO',
  Miniapp_ad_prolong_promo = 'MINIAPP_AD_PROLONG_PROMO',
}

export const InvoicePeriod = {
  DAYS_30: 'DAYS_30',
  DAYS_60: 'DAYS_60',
  DAYS_90: 'DAYS_90',
  DAYS_180: 'DAYS_180',
} as const;

export type InvoicePeriod = (typeof InvoicePeriod)[keyof typeof InvoicePeriod];

export const InvoiceStartsAt = {
  MAX_EXPIRES_DATE: 'MAX_EXPIRES_DATE',
  TODAY: 'TODAY',
} as const;

export type InvoiceStartsAt =
  (typeof InvoiceStartsAt)[keyof typeof InvoiceStartsAt];

export type Invoice = {
  amount: number;
  contractNumber: string | null;
  customerName: string | null;
  customerTin: string | null;
  discount: number | null;
  expiresAt: string;
  id: string;
  invoiceDate: string;
  legacyResourceId: number;
  paidAdsCount: number | null;
  paymentSource: string | null;
  printUrl: string | null;
  service: string;
  startsAt: string;
  status: string;
  statusDatetime: string;
  vatAmount: number | null;
  walletAmount: number | null;
};

export type CreateInvoiceResponse = {
  createInvoice: MutationResponse<Invoice>;
};

export type CreateInvoiceVariables = {
  period: InvoicePeriod;
  startsAt: InvoiceStartsAt;
  tariffPlanTitle: string;
};

export type PaymentResult = {
  amount: number | null;
  status: PaymentStatus;
  redirectUrl?: string;
  paymentLegacyId?: string;
  paymentDate?: string;
  paymentMethod: PaymentMethod | null;
  serviceName: string | null;
  targetLegacyId?: string;
  provider: PaymentProvider;
};

export type CreatePaymentResponse = {
  createPayment: MutationResponse<PaymentResult>;
};

export type CreateTerminalPaymentResponse = {
  createTerminalPayment: MutationResponse<boolean>;
};

export type FinishedPayment = {
  amount: number;
  paymentLegacyId: number;
  serviceId: string;
  serviceName: string;
  paymentMethod: PaymentMethod;
  targetLegacyId: number;
  updatedAt: string;
};

type FinishedPaymentResult = {
  success: boolean;
  alreadyFinished: boolean;
  message?: string;
  payment: FinishedPayment;
};

export type FinishPaymentResponse = {
  finishPayment: MutationResponse<FinishedPaymentResult>;
};
